

































import { SfImage } from '~/components/StorefrontUi';
import { computed, useContext, useRouter } from '@nuxtjs/composition-api';
import { PropType } from 'vue';
import { addBasePath } from '~/helpers/addBasePath';
import { ISbStoryData } from '@storyblok/js/dist/types';
import getFormattedDate from '~/helpers/getFormattedDate';

export default {
  name: 'BlogNewsArticleTile',
  components: {
    SfImage,
  },
  props: {
    article: {
      type: Object as PropType<any>,
      default: () => {},
    },
  },
  setup({ article }: { article: ISbStoryData; type: string }) {
    const router = useRouter();
    const { $localeSbUrl } = useContext();

    const linkToArticle = computed(() => $localeSbUrl({
      slug: article.default_full_slug,
    }));

    const pushToUrl = () => {
      router.push(linkToArticle.value);
    };

    return {
      pushToUrl,
      addBasePath,
      linkToArticle,
      getFormattedDate,
      bgFilename: computed(() => (article?.content?.preview?.cached_url
        ? article.content.preview.cached_url
        : '')),
      description: computed(() => (article?.content?.description ? article.content.description : '')),
      date: computed(() => (
        article?.first_published_at || article?.created_at
      )),
    };
  },
};
